import { _$LH as m } from "../beacon-html.d/index.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: p } = m, f = (e) => e === null || typeof e != "object" && typeof e != "function", u = { HTML: 1, SVG: 2 }, g = (e, t) => t === void 0 ? (e == null ? void 0 : e._$litType$) !== void 0 : (e == null ? void 0 : e._$litType$) === t, P = (e) => {
  var t;
  return ((t = e == null ? void 0 : e._$litType$) == null ? void 0 : t.h) != null;
}, T = (e) => (e == null ? void 0 : e._$litDirective$) !== void 0, x = (e) => e == null ? void 0 : e._$litDirective$, y = (e) => e.strings === void 0, n = () => document.createComment(""), B = (e, t, i) => {
  var _;
  const l = e._$AA.parentNode, r = t === void 0 ? e._$AB : t._$AA;
  if (i === void 0) {
    const $ = l.insertBefore(n(), r), a = l.insertBefore(n(), r);
    i = new p($, a, e, e.options);
  } else {
    const $ = i._$AB.nextSibling, a = i._$AM, A = a !== e;
    if (A) {
      let s;
      (_ = i._$AQ) == null || _.call(i, e), i._$AM = e, i._$AP !== void 0 && (s = e._$AU) !== a._$AU && i._$AP(s);
    }
    if ($ !== r || A) {
      let s = i._$AA;
      for (; s !== $; ) {
        const c = s.nextSibling;
        l.insertBefore(s, r), s = c;
      }
    }
  }
  return i;
}, C = (e, t, i = e) => (e._$AI(t, i), e), v = {}, S = (e, t = v) => e._$AH = t, b = (e) => e._$AH, R = (e) => {
  var l;
  (l = e._$AP) == null || l.call(e, !1, !0);
  let t = e._$AA;
  const i = e._$AB.nextSibling;
  for (; t !== i; ) {
    const r = t.nextSibling;
    t.remove(), t = r;
  }
}, D = (e) => {
  e._$AR();
};
export {
  u as TemplateResultType,
  D as clearPart,
  b as getCommittedValue,
  x as getDirectiveClass,
  B as insertPart,
  P as isCompiledTemplateResult,
  T as isDirectiveResult,
  f as isPrimitive,
  y as isSingleExpression,
  g as isTemplateResult,
  R as removePart,
  C as setChildPartValue,
  S as setCommittedValue
};
